/**
 * Switch pomiedzy dwoma backendami asystenta AI:
 *  - Orion (zewnetrzny serwis pod REACT_APP_CHAT_API_BASE_URL) — default,
 *  - WiseAi (nasz backend, /api/ui/assistant-ai/*) — gdy REACT_APP_WISE_AI=true.
 *
 * Funkcje maja te same sygnatury — `useHydraAIAssistant.ts` konsumuje je bez zmian.
 * Wybor implementacji odbywa sie raz przy starcie (zmienne process.env sa
 * wbudowywane w build).
 */

import { isWiseAiEnabled } from 'config/wiseAi';

import * as orion from './orionEndpoints';
import * as wiseAi from './wiseAiEndpoints';

const impl = isWiseAiEnabled() ? wiseAi : orion;

export const createThread = impl.createThread;
export const updateThreadContext = impl.updateThreadContext;
export const addMessage = impl.addMessage;
export const getThreadContent = impl.getThreadContent;
export const addAttachment = impl.addAttachment;
export const removeAttachment = impl.removeAttachment;
export const cancelProcessing = impl.cancelProcessing;
export const removeLastMessage = impl.removeLastMessage;
export const getAttachments = impl.getAttachments;
